module.exports = __webpack_public_path__ + "img/8.13278a89.jpg";